import { Button } from "@circleco/compass/components/Button";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

interface SpaceGroupMembersEmptyStateProps {
  addMemberButtonLabel: string;
  onAddMembers: () => void;
}

export const SpaceGroupMembersEmptyState = ({
  addMemberButtonLabel,
  onAddMembers,
}: SpaceGroupMembersEmptyStateProps) => (
  <div className="flex flex-col items-center gap-6 py-12 text-center">
    <div className="flex max-w-sm flex-col items-center gap-3">
      <Typography variant="heading-md">
        {t(["space_groups.form.edit.members", "no_members"])}
      </Typography>
      <Typography variant="body-sm" color="secondary">
        {t(["space_groups.form.edit.members", "there_are_no_members"])}
      </Typography>
    </div>
    <Button variant="outline" onClick={onAddMembers}>
      {addMemberButtonLabel}
    </Button>
  </div>
);
